/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert Phred quality scores to error probability, accuracy and ASCII characters.`)
};

const es_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte puntuaciones de calidad Phred a probabilidad de error, precisión y caracteres ASCII.`)
};

const de_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertieren Sie Phred-Qualitätswerte in Fehlerwahrscheinlichkeit, Genauigkeit und ASCII-Zeichen.`)
};

const nl_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet Phred-kwaliteitsscores om naar foutkans, nauwkeurigheid en ASCII-tekens.`)
};

const fr_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez les scores de qualité Phred en probabilité d'erreur, précision et caractères ASCII.`)
};

const it_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte i punteggi di qualità Phred in probabilità di errore, accuratezza e caratteri ASCII.`)
};

const pt_br2_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta escores de qualidade Phred em probabilidade de erro, precisão e caracteres ASCII.`)
};

const pt_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta pontuações de qualidade Phred em probabilidade de erro, precisão e caracteres ASCII.`)
};

const ja_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred品質スコアをエラー確率、精度、ASCII文字に変換します。`)
};

const zh_phred_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 Phred 质量分数转换为错误概率、准确率和 ASCII 字符。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_tool_description", locale)
	if (locale === "en") return en_phred_tool_description(inputs)
	if (locale === "es") return es_phred_tool_description(inputs)
	if (locale === "de") return de_phred_tool_description(inputs)
	if (locale === "nl") return nl_phred_tool_description(inputs)
	if (locale === "fr") return fr_phred_tool_description(inputs)
	if (locale === "it") return it_phred_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_phred_tool_description(inputs)
	if (locale === "pt") return pt_phred_tool_description(inputs)
	if (locale === "ja") return ja_phred_tool_description(inputs)
	return zh_phred_tool_description(inputs)
};